import { z } from 'zod'

export const termsSearchSchema = z.object({
  agreementType: z.enum(['user', 'wallet']),
  pageNumber: z.number().optional(),
})
